import React, { useEffect, useState } from 'react';
import Table from '../Table';

const Dashboard = () => {
  const [data, setData] = useState([]); // Initialize as an empty array
  const [error, setError] = useState(null);

  // Define the data-fetching function
  const fetchData = () => {
    fetch('https://traddapp.com/upx_holdings')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Parse the JSON response
      })
      .then((data) => {
        console.log('Fetched Data:', data); // Debug the response
        setData(data); // Update state with the new data
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setError(err.message);
      });
  };

  useEffect(() => {
    // Fetch data on component mount
    fetchData();

    // Set up the interval to refresh data every 10 seconds
    const interval = setInterval(fetchData, 60000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this runs once on mount

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Portfolio</h1>
      </div>
      <section className="section dashboard">
        <div className="row">
          <Table data={data} />
        </div>
      </section>
    </main>
  );
};

export default Dashboard;
